import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListChargePointModelCell } from './channel-list-charge-point-model.cell';
import { ChannelListChargePointModelHeader } from './channel-list-charge-point-model.header';

export const ChannelListChargePointModelColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['chargePointModel']
> = {
  enableSorting: false,
  header: ChannelListChargePointModelHeader,
  cell: ChannelListChargePointModelCell,
};
